module.exports = __webpack_public_path__ + "u.no1.88d3a367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/u.no1.jpg
// module id = lfoC
// module chunks = 0